import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=6058d450&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
import style0 from "./Phone.vue?vue&type=style&index=0&id=6058d450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058d450",
  null
  
)

export default component.exports